import BetStatusCorrectionActionType from 'actions/betStatusCorrection/betStatusCorrectionActionType';

const initialState = {
  singleBetStatusCorrections: {},
  bulkBetStatusCorrections: {},
  betStatusCorrectionsStatistics: {},
  csvBetCorrections: [],
  endedStatus: false,
};

const betStatusCorrectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case BetStatusCorrectionActionType.SAVE_SINGLE_BET_STATUS_CORRECTIONS:
    return {
      ...state,
      singleBetStatusCorrections: payload.data,
    };
  case BetStatusCorrectionActionType.RESET_SINGLE_BET_STATUS_CORRECTIONS:
    return {
      ...state,
      singleBetStatusCorrections: {},
    };
  case BetStatusCorrectionActionType.SAVE_BULK_BET_STATUS_CORRECTIONS:
    return {
      ...state,
      bulkBetStatusCorrections: payload.data,
    };
  case BetStatusCorrectionActionType.RESET_BULK_BET_STATUS_CORRECTIONS:
    return {
      ...state,
      bulkBetStatusCorrections: {},
    };
  case BetStatusCorrectionActionType.SAVE_BET_STATUS_CORRECTIONS_STATISTICS:
    return {
      ...state,
      betStatusCorrectionsStatistics: payload.data,
    };
  case BetStatusCorrectionActionType.RESET_BET_STATUS_CORRECTIONS_STATISTICS:
    return {
      ...state,
      betStatusCorrectionsStatistics: {},
    };
  case BetStatusCorrectionActionType.SAVE_CSV_BET_CORRECTIONS:
    return {
      ...state,
      csvBetCorrections: payload.data,
    };
  case BetStatusCorrectionActionType.RESET_CSV_BET_CORRECTIONS:
    return {
      ...state,
      csvBetCorrections: [],
    };
  case BetStatusCorrectionActionType.CHANGE_BET_CORRECTIONS_ENDED_STATUS:
    return {
      ...state,
      endedStatus: payload.status,
    };
  default:
    return state;
  }
};

export default betStatusCorrectionReducer;
